import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import transferService from '../services/transfer.service'
import { TransferData } from '../apis/transfer.api'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import Map, { MapCoordinate } from '../components/Map'

interface InventoryLocationMapProps {
  transfers: TransferData[]
}

export default class InventoryLocationMap
  extends Component<InventoryLocationMapProps> {
  get coordinates (): MapCoordinate[] {
    return transferService.mapCoordinates(this.props.transfers)
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Location on Map")} />
        <Map coordinates={this.coordinates} />
      </Card>
    )
  }
}
